import requests from "./customRequests/requests";

import { message } from "antd";

const mail = localStorage.getItem("mockUser") ? `?mail=${localStorage.getItem("mockUser")}` : ""

export const getAdvanceReceiptReport = async (params) => {
  const resp = await requests().get(`api/Report/BCAdvanceReceiptReport`,{params});
  return resp?.data;
};

// 是否為報表代查者(檢視者/測試人員) → 前端決定是否顯示「以他人身分檢視」下拉
export const getReportCanImpersonate = async () => {
  const resp = await requests().get(`api/Report/CanImpersonate`);
  return resp?.data;
};

export const BCOverDueARReport = async (params) => {
  const resp = await requests().get(`api/Report/BCOverDueARReport`,{params});
  return resp?.data;
};


export const BCOverDueARExcel = async (params) => {
  const resp = await requests().get(`api/Report/BCOverDueARReport/Excel`,{
    "responseType": "arraybuffer",
    "params":params
  });
  return resp?.data;
};